import { Navigate } from "react-router-dom";
import Dashboard from "./Dashboard";
import PlannerDashboard from "./Planner/PlannerDashboard";
import { hasPlannerView } from "../../utils/moduleAccess";

const DashboardRedirect = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};

  if (hasPlannerView(user)) {
    return <PlannerDashboard />;
  }

  return <Dashboard />;
};

export default DashboardRedirect;